import React from 'react';
import { Badge, Box, Flex, Icon, Text } from '@chakra-ui/react';
import { Buildings, CaretRight, Receipt } from 'phosphor-react';
import { IDifalCarteiraEmpresa } from '../../../../../../types/icms';
import { formatCNPJ, formatCurrency, toNumber } from '../../../../../../utils/FormatFunctions';

interface DifalEmpresaCardProps {
  empresa: IDifalCarteiraEmpresa;
  // eslint-disable-next-line no-unused-vars
  onClick: (empresa: IDifalCarteiraEmpresa) => void;
}

export function DifalEmpresaCard({ empresa, onClick }: DifalEmpresaCardProps) {
  const total = toNumber(empresa.total_difal);
  const nome = empresa.razao_social || empresa.nome;

  return (
    <Box
      bg="white"
      borderRadius="xl"
      border="1px"
      borderColor="gray.200"
      p={4}
      cursor="pointer"
      transition="all 0.2s"
      role="group"
      _hover={{
        borderColor: 'orange.300',
        boxShadow: 'md',
        transform: 'translateY(-2px)',
      }}
      onClick={() => onClick(empresa)}
    >
      <Flex justify="space-between" align="center" mb={3} gap={2}>
        <Text fontSize="xs" fontWeight="bold" color="gray.500">
          #{empresa.codi_emp}
        </Text>
        {empresa.uf && (
          <Badge colorScheme="orange" fontSize="2xs" px={2} borderRadius="full">
            {empresa.uf}
          </Badge>
        )}
      </Flex>

      <Flex align="center" gap={2} mb={1}>
        <Icon as={Buildings} color="#F57C00" boxSize={5} flexShrink={0} />
        <Text fontSize="sm" fontWeight="semibold" color="gray.800" noOfLines={2}>
          {nome || 'Empresa não identificada'}
        </Text>
      </Flex>
      <Text fontSize="xs" color="gray.500" pl={7} mb={3}>
        {empresa.cnpj ? formatCNPJ(empresa.cnpj) : '—'}
      </Text>

      <Box borderTop="1px" borderColor="gray.100" pt={3}>
        <Flex justify="space-between" align="flex-end" gap={2}>
          <Box>
            <Text fontSize="2xs" color="gray.500" textTransform="uppercase" fontWeight="bold">
              Total DIFAL
            </Text>
            <Text fontSize="lg" fontWeight="bold" color="#F57C00" lineHeight="1.2">
              {formatCurrency(total)}
            </Text>
          </Box>
          <Flex align="center" gap={1}>
            <Icon as={Receipt} color="gray.400" boxSize={4} />
            <Text fontSize="xs" color="gray.600" fontWeight="medium">
              {empresa.qtd_notas} {empresa.qtd_notas === 1 ? 'nota' : 'notas'}
            </Text>
          </Flex>
        </Flex>
      </Box>

      <Flex
        justify="flex-end"
        align="center"
        gap={1}
        mt={2}
        color="gray.400"
        _groupHover={{ color: '#F57C00' }}
        transition="color 0.2s"
      >
        <Text fontSize="xs" fontWeight="medium">
          Ver detalhe
        </Text>
        <Icon as={CaretRight} boxSize={3} weight="bold" />
      </Flex>
    </Box>
  );
}
